import ConfirmModal from "kustom-front/src/components/molecules/ConfirmModal";
import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import "./style.scss";

interface Props {
  display: boolean;
}

const CartEmptyModal: FunctionComponent<Props> = ({ display }) => {
  const intl = useIntl();

  return (
    <ConfirmModal
      confirmLabel={intl.formatMessage({ id: "cheerz_confirm" })}
      display={display}
      onDismiss={() => {
        window.location.href = "categories/all";
      }}
      showDismissButton={false}
    >
      <div className="CartEmptyModal">
        <div className="CartEmptyModal-content">
          <h3 className="CartEmptyModal-title">
            {intl.formatMessage({
              id: "cheerz_CartEmptyModal_emptyCart",
            })}
          </h3>
          <div className="CartEmptyModal-description">
            {intl.formatMessage({
              id: "cheerz_CartEmptyModal_goBuy",
            })}
          </div>
        </div>
      </div>
    </ConfirmModal>
  );
};

export default CartEmptyModal;
